import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  text: {
    textAlign: 'inherit',
    fontWeight: 'inherit'
  },
  date: {
    fontWeight: 'inherit',
    color: 'inherit'
  }
}))
